module.exports = __webpack_public_path__ + "static/media/img170.1e8bcf83.jpg";